import { StyleSheet, View, ViewProps } from 'react-native'
import { BrandingIdentity, Spacing } from 'zens-storybook'
import { PropsWithChildren, Suspense } from 'react'
import { Link } from 'zens-router'
import { ErrorBoundary } from 'react-error-boundary'
import { Redirect } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    position: 'absolute',
    top: Spacing.L,
    right: Spacing.L,
  },
})

interface Props extends ViewProps {}

const AuthLayout = (props: PropsWithChildren<Props>) => {
  const { children, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <ErrorBoundary
        fallbackRender={({ error }) => {
          const status = (error as any)?.status
          const message = (error as any)?.message

          if (status === 401 && message === 'Token expired.') {
            return <Redirect href="/token-expired" />
          }

          throw error
        }}
      >
        <Suspense fallback={null}>{children}</Suspense>
      </ErrorBoundary>
      <Link href="/email" asChild style={styles.header}>
        <BrandingIdentity size="XL" />
      </Link>
    </View>
  )
}

export default AuthLayout
